import 'isomorphic-fetch'
import config from '../../../server/config/server'

const getOneReference = id => new Promise((resolve, reject) => {
    fetch(`${config.baseUrl}/api/v1/references/${id}`)
        .then(response => response.json())
        .then((result) => {
            resolve(result.d[0])
        })
        .catch(() => {
            reject('there was an error with API call')
        })
})

export default getOneReference



// WEBPACK FOOTER //
// ./src/scripts/api/getOneReference.js